import React from 'react';
import styles from './logs.module.scss';
import { tracker } from '@archre2/react-core';
import ActionRow from './actionRow';
import ErrorRow from './errorRow';

export function downloadLogs() {
  let element = document.createElement('a');
  let file = new Blob([JSON.stringify(tracker.get())], {
    type: 'application/json',
  });
  element.href = URL.createObjectURL(file);
  element.download = `vitamins-logs-${new Date().toISOString()}.json`;
  element.click();
  URL.revokeObjectURL(element.href);
}

export default function LogsPage({ className = '' }) {
  const [tab, setTab] = React.useState('errors');
  const [items, setItems] = React.useState(tracker.get());

  function clear() {
    tracker.clear();
    localStorage.clear();
    setItems(tracker.get());
  }

  return (
    <div className={`${styles.page} ${className}`}>
      <div className={styles.header}>
        <div className={styles.switcher}>
          <button
            onClick={() => setTab('errors')}
            className={tab === 'errors' ? styles.selected : ''}
          >
            errors
          </button>
          <button
            onClick={() => setTab('actions')}
            className={tab === 'actions' ? styles.selected : ''}
          >
            actions
          </button>
        </div>
        <div className={styles.search} />
        <button type="button" className={styles.button} onClick={downloadLogs}>
          download
        </button>
        <button type="button" className={styles.button} onClick={clear}>
          clear
        </button>
      </div>
      <ul className={styles.list}>
        {items[tab].map((l, i) =>
          tab === 'actions' ? (
            <ActionRow key={i} item={l} />
          ) : (
            <ErrorRow key={i} item={l} />
          )
        )}
      </ul>
    </div>
  );
}
